var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector44(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 402,
    viewBox: "0 0 237 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.636 400.804C210.783 374.272 207.031 368.725 192.521 343.028C188.966 336.733 183.666 324.717 179.034 310.142C177.645 305.781 176.433 301.478 175.362 297.253C167.733 267.022 170.547 234.733 177.641 203.443C195.745 123.609 162.14 44.6184 98.8805 14.1654C35.5117 -16.3375 -43.0055 8.46013 -86.5358 58.128C-92.1993 64.5908 -117.486 95.2875 -125.649 131.686C-151.455 246.605 -45.29 308.702 121.18 367.676C124.419 368.821 139.928 373.627 143.23 374.56L235.646 400.817L235.636 400.804Z",
    stroke: "#E1E3E9",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector44);
export default __webpack_public_path__ + "static/media/vector4-4.4b5bb8c051ac08a9841aab73bf7da0f7.svg";
export { ForwardRef as ReactComponent };